// ─── useModifie — détection de modification d'un formulaire — Core ──
// Factorise le pattern « disquette grisée tant que rien n'a changé » :
//   const { modifie, capturer } = useModifie(objComparable);
//   … capturer() à l'ouverture (une fois les champs chargés) …
//   action.disabled = !valide || !modifie
// `objComparable` = uniquement les champs qui comptent (sérialisables JSON).
import { useRef } from 'react';

export function useModifie(valeurCourante) {
  const ref = useRef(undefined);
  const cle = JSON.stringify(valeurCourante ?? null);
  return {
    modifie: ref.current !== undefined && cle !== ref.current,   // courant ≠ instantané d'ouverture
    // Fige l'état de référence : la valeur courante, ou une valeur initiale explicite
    // (utile quand on connaît l'objet à l'ouverture avant un setState asynchrone).
    capturer: (valeurInitiale) => { ref.current = valeurInitiale === undefined ? cle : JSON.stringify(valeurInitiale ?? null); },
    oublier: () => { ref.current = undefined; },                 // à la fermeture (optionnel)
  };
}
